import React from 'react';
import PropTypes from 'prop-types';
import './StatusBadge.css';

/**
 * StatusBadge - Component for displaying status indicators
 * @param {string} status - Status type: 'active', 'inactive', 'pending', 'rejected'
 * @param {string} label - Optional custom label (defaults to status name)
 */
function StatusBadge({ status, label }) {
  const statusConfig = {
    active: {
      className: 'status-badge-active',
      defaultLabel: 'Aktywne'
    },
    inactive: {
      className: 'status-badge-inactive',
      defaultLabel: 'Nieaktywne'
    },
    pending: {
      className: 'status-badge-pending',
      defaultLabel: 'Oczekujące'
    },
    rejected: {
      className: 'status-badge-rejected',
      defaultLabel: 'Odrzucone'
    },
    ended: {
      className: 'status-badge-ended',
      defaultLabel: 'Zakończone'
    },
    draft: {
      className: 'status-badge-draft',
      defaultLabel: 'Szkic'
    }
  };

  const config = statusConfig[status] || statusConfig.inactive;
  const displayLabel = label || config.defaultLabel;

  return (
    <span className={`status-badge ${config.className}`}>
      {displayLabel}
    </span>
  );
}

StatusBadge.propTypes = {
  status: PropTypes.oneOf(['active', 'inactive', 'pending', 'rejected', 'draft', 'ended']).isRequired,
  label: PropTypes.string
};

export default StatusBadge;

